// BM-service侧
// https://km.qutoutiao.net/pages/viewpage.action?pageId=210505996

// Mkt-Api侧
// https://km.qutoutiao.net/pages/viewpage.action?pageId=193220306

// Nagato侧
// https://km.qutoutiao.net/pages/viewpage.action?pageId=209326213

import request from './request';

// common
// 获取枚举:{enum_type: status|account_type|ad_account_type}
export async function getEnum(params) {
  return request({
    url: '/enums/get',
    method: 'get',
    params,
  });
}
export async function getDataInfo(params) {
  return request({
    url: '/statistics/get',
    method: 'get',
    params,
  });
}

// 登录
export async function doLogin(data) {
  let res = request({
    url: '/v3/login',
    method: 'post',
    baseURL: process.env.VUE_APP_SSO_HOST,
    data: {
      env: process.env.VUE_APP_SSO_ENV,
      cid: process.env.VUE_APP_SSO_CLIENT_ID,
      ...data,
    },
  });
  return res;
}

// 登录状态判断
export async function loginStatus(params) {
  return request({
    url: '/user/check_status',
    method: 'get',
    params,
  });
}

// 获取登录验证码
export async function getLoginCode() {
  return request({
    baseURL: process.env.VUE_APP_SSO_HOST,
    url: 'captcha/mktapi',
    method: 'get',
    responseType: 'blob',
  });
}

// 退出登录
export async function doLogout() {
  return request({
    baseURL: process.env.VUE_APP_SSO_HOST,
    url: '/v3/logout',
    method: 'post',
    data: {
      env: process.env.VUE_APP_SSO_ENV,
      cid: process.env.VUE_APP_SSO_CLIENT_ID,
    },
  });
}

// 获取登录信息
export async function getUserInfo() {
  return request({ url: '/user/info', method: 'get' });
}

// 协议签署
export async function signAgreement() {
  return request({ url: '/user/sign/agreement', method: 'post' });
}

/** 注册开发者相关 */
// 获取注册信息
export async function getDevInfo() {
  return request({ url: '/user/dev_info', method: 'get' });
}
// 提交注册信息
export async function submitDevInfo() {
  return request({ url: '/user/dev_register', method: 'get' });
}

/** 应用相关 */
// 创建应用
export async function createApp(data) {
  return request({ url: '/app/create', method: 'post', data });
}
// 修改应用
export async function updateApp(data) {
  return request({ url: '/app/update', method: 'post', data });
}
// 获取应用列表
export async function getAppList(params) {
  return request({ url: '/app/list', method: 'get', params });
}

/** 授权相关 */
// 获取授权列表
export async function getAuthList(params) {
  return request({ url: '/app/auth/list', method: 'get', params });
}
// 获取账户列表
export async function getAccountList(params) {
  return request({ url: '/third/account/list', method: 'get', params });
}
// 申请授权
export async function applyAuth(data) {
  return request({ url: 'app/auth/apply', method: 'post', data });
}
// 取消授权
export async function cancelAuth(data) {
  return request({ url: 'app/auth/remove', method: 'post', data });
}
